/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Transaction,
    TransactionFromJSON,
    TransactionFromJSONTyped,
    TransactionToJSON,
} from './';

/**
 * A list of consensus transactions.
 * @export
 * @interface TransactionListAllOf
 */
export interface TransactionListAllOf {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof TransactionListAllOf
     */
    transactions: Array<Transaction>;
}

export function TransactionListAllOfFromJSON(json: any): TransactionListAllOf {
    return TransactionListAllOfFromJSONTyped(json, false);
}

export function TransactionListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': ((json['transactions'] as Array<any>).map(TransactionFromJSON)),
    };
}

export function TransactionListAllOfToJSON(value?: TransactionListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': ((value.transactions as Array<any>).map(TransactionToJSON)),
    };
}


